import React, { createContext, useState, useEffect, useCallback } from 'react';
import i18n, { LANGUAGES, STORAGE_KEY, currentLanguage } from '../../i18n';
import { applyMyLanguage } from '../../services/kullaniciDilService';

// LanguageContext'in oluşturulması
export const LanguageContext = createContext();

// WAS (until #332):
// export const LanguageProvider = ({ children }) => {
//   const [selectedLang, setSelectedLang] = useState(localStorage.getItem('appLanguage') || 'tr');
//
//   useEffect(() => {
//     localStorage.setItem('appLanguage', selectedLang);
//   }, [selectedLang]);
//   ...same Provider below
// };
// #332 (2026-10-12): the selection also drives i18next (every t() call), <html lang>, and, through
// getAuthHeader()/getPublicHeader(), the Accept-Language the backend answers names in.
export const LanguageProvider = ({ children }) => {
  const [selectedLang, setSelectedLangState] = useState(currentLanguage());

  // i18next switches HERE, not in the effect below: effects run child-first, so a child refetching
  // on the new selectedLang (Header's fair list) would otherwise still send the old Accept-Language.
  // WAS (until #562): a plain function re-created on every render
  const setSelectedLang = useCallback((lang) => {
    const next = LANGUAGES.includes(lang) ? lang : 'tr';
    if (i18n.language !== next) i18n.changeLanguage(next);
    setSelectedLangState(next);
  }, []);

  // #562: the language is the USER's. A page load with a session (the login page does the same right after a login) takes the saved
  // language from the server, so a choice made in another browser follows the user here. No session: the browser's last language stays.
  useEffect(() => {
    let token = null;
    try { token = localStorage.getItem('token'); } catch (e) { /* storage closed */ }
    if (token) applyMyLanguage(setSelectedLang);
  }, [setSelectedLang]);

  useEffect(() => {
    try { localStorage.setItem(STORAGE_KEY, selectedLang); } catch (e) { /* private mode: keep it for this tab */ }
    if (i18n.language !== selectedLang) i18n.changeLanguage(selectedLang);
    document.documentElement.lang = selectedLang;
  }, [selectedLang]);

  return (
    <LanguageContext.Provider value={{ selectedLang, setSelectedLang }}>
      {children}
    </LanguageContext.Provider>
  );
};
